import React, { Component } from 'react';
import { Modal, Toast } from 'antd-mobile';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Http from '../../config/axiosUtils';
import { removeStore } from '../../config/storage';
import ListItem from '../../components/common/ListItem';
import '../../assets/scss/Personal/profile.scss';

class Profile extends Component {
  state = {
    profileData: {},
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const path = '/spread/web/user/account/info';
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        profileData: res.data
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //退出登录
  loginOutConfirm = () => {
    Modal.alert('提示', '确定退出登录吗？', [{text: '取消'}, {text: '确定', onPress: this.loginOut}]);
  }

  loginOut = async () => {
    const path = '/spread/web/user/logout';
    const res = await Http.get(path);
    if (res.code === 0) {
      removeStore('token');
      this.props.history.replace('/login');
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  render () {
    const { profileData } = this.state;
    return (
      <div className='profile'>
        <Helmet><title>个人资料</title></Helmet>
        <div className='profile-module'>
          <ListItem name='姓名' value={profileData.name}></ListItem>
          <ListItem name='手机号' value={profileData.mobile}></ListItem>
          <ListItem name='身份证号' value={profileData.cardId}></ListItem>
        </div>
        <div className='profile-module'>
          <ListItem name='等级' value={profileData.level || '——'}></ListItem>
          <ListItem name='团队' value={profileData.teamLevelName || '——'}></ListItem>
          <ListItem name='推荐人' value={profileData.referrerName || '——'}></ListItem>
          <ListItem name='推荐人手机号' value={profileData.referrerMobile || '——'}></ListItem>
        </div>
        <div className='profile-module'>
          <Link to='/password'>
            <ListItem name='支付密码' value={profileData.payPassword ? '去修改' : '去设置'} hasMore></ListItem>
          </Link>
        </div>
        <div className='profile-module' onClick={this.loginOutConfirm}>
          <ListItem name='退出登录'></ListItem>
        </div>
      </div>
    )
  }
}

export default Profile;